var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"swipe-container",style:({
    '--width': isNaN(_vm.width) ? _vm.width : _vm.width + 'px',
    '--height': isNaN(_vm.height) ? _vm.height : _vm.height + 'px',
    '--spacing': isNaN(_vm.spacing) ? _vm.spacing : _vm.spacing + 'px',
    '--scale': _vm.scale + _vm.deltaScaleLeft + _vm.deltaScaleRight,
    '--left': _vm.left,
    '--delta-left': _vm.deltaLeft,
    '--delta-right': _vm.deltaRight,
    '--delta-scale-left': 1 - _vm.deltaScaleRight,
    '--delta-scale-right': 1 - _vm.deltaScaleLeft,
    '--index-left': _vm.indexLeft,
    '--index-right': _vm.indexRight,
    '--transition': _vm.transition,
  }),on:{"touchstart":function($event){_vm.disabled ? undefined : _vm.handleTouchstart},"touchmove":function($event){_vm.disabled ? undefined : _vm.handleTouchmove}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }